
export const FormatoInscripcionLang = {
    // ENCABEZADO
    codigoP: {
        es: 'Código de Proveedor',
        en: 'Vendor Code',
    },
    'cuentaBancariaNacional': {
        'es': 'Dichos depósitos deberán efectuarse en la cuenta No.',
        'en': 'Such deposits must be made in account No.'
    },
    'aNombreDe': {
        'es': 'A nombre de',
        'en': 'In favor of'
    },
    'Banco': {
        'es': 'Banco',
        'en': 'Bank'
    },
    'RTN': {
        'es': 'RTN de la empresa',
        'en': 'Company RTN'
    },
    'tipoCuenta': {
        'es': 'Tipo de cuenta',
        'en': 'Account type'
    },
    'Moneda': {
        'es': 'Moneda',
        'en': 'Currency'
    },
    'CorreoNotificacionPago': {
        'es': 'Correo electrónico para notificación de pagos',
        'en': 'Email for payment notification'
    },
    'TelefonoSmall': {
        'es': 'Tel.',
        'en': 'Phone'
    },



    // TABLAS
    textInicial: {
        es: 'FORMATO DE INSCRIPCIÓN DE PROVEEDORES CSM-PPCVI V1',
        en: 'CSM-PPCVI V1 SUPPLIER REGISTRATION FORM: ',
    },
    tipoSolicitud: {
        es: 'Tipo de Solicitud:  ',
        en: 'Type of Request: ',
    },
    inscripcion: {
        es: 'Inscripción:  ',
        en: 'Inscription: ',
    },
    actualizacion: {
        es: 'Actualización: ',
        en: 'Update: ',
    },


    // TABLA PRINCIPAL
    parteI: {
        es: 'PARTE I: INFORMACIÓN GENERAL',
        en: 'PART I: GENERAL INFORMATION',
    },
    casaMatriz: {
        es: 'Nombre de la casa matriz',
        en: 'Name of parent company',
    },
    pais: {
        es: 'País de constitución',
        en: 'Country of incorporation',
    },
    identificacionTributaria: {
        es: 'Número de Identificación Tributaria',
        en: 'Tax Identification',
    },
    nombre: {
        es: 'Nombre Comercial (Si es distinto al nombre comercial)',
        en: 'Commercial Name (If different from the commercial name)',
    },
    direccionC: {
        es: 'Dirección comercial (Si es distinto al anterior)',
        en: 'Commercial address (If different from the previous one)',
    },
    nTel: {
        es: 'Número de teléfono de referencia',
        en: 'Reference telephone number',
    },
    contacto: {
        es: 'Contacto de cuentas por cobrar (Persona encargada de confirmar pagos):',
        en: 'Accounts Receivable Contact (Person in charge of confirming payments):',
    },
    representanteL: {
        es: 'Representante legal:',
        en: 'Legal representative:',
    },
    actividad: {
        es: 'Prinncipal actividad económica:',
        en: 'Main economic activity:',
    },

    parteII: {
        es: 'PARTE II: REFERENCIAS COMERCIALES',
        en: 'PART II: COMMERCIAL REFERENCES',
    },
    nombreC: {
        es: 'Nombre de la compañía',
        en: ' Name of the company',
    },

    parteIII: {
        es: 'PARTE III: INFORMACIÓN BANCARIA',
        en: 'PART III: BANK INFORMATION',
    },
    text3: {
        es: '*Esta información es muy importante. Los datos se validaran mediante llamada telefónica al recibir el formulario completo.',
        en: '*This information is very important. The data will be validated by phone call upon receipt of the completed form.',
    },
    bancoNacional: {
        es: 'BANCO NACIONAL',
        en: 'NATIONAL BANK'
    },
    bancoI: {
        es: 'BANCO INTERMEDIARIO',
        en: 'INTERMEDIARY BANK',
    },
    nombreB: {
        es: 'Nombre del Banco:',
        en: 'Name of the bank:',
    },
    direccionB: {
        es: 'Dirección del banco:',
        en: 'Bank address:',
    },
    numeroCuenta: {
        es: 'Número de cuenta:',
        en: 'Account number:',
    },
    bancoB: {
        es: 'BANCO BENEFICIARIO',
        en: 'BENEFICIARY BANK',
    },
    nombreBeneficiario: {
        es: 'Nombre del Beneficiario:',
        en: 'Name of Beneficiary:',
    },


    codigo: {
        es: 'CÓDIGO',
        en: 'CODE',
    },
    producto: {
        es: 'PRODUCTO',
        en: 'PRODUCT',
    },
    unidad: {
        es: 'UNIDAD',
        en: 'UNIT',
    },
    precio: {
        es: 'PRECIO',
        en: 'PRICE',
    },
    isv: {
        es: 'ISV',
        en: 'TAX',
    },
    descuento: {
        es: 'DESC.',
        en: 'DISC.',
    },
    descripcion: {
        es: 'DESCRIPCION.',
        en: 'DESCRIPTION.',
    },


    desc: {
        es: 'Desc.',
        en: 'Disc.',
    },
    fletes: {
        es: 'Fletes.',
        en: 'Freigths.',
    },
    otros: {
        es: 'Otros.',
        en: 'Others.',
    },

    terminosPago: {
        es: 'Términos de Pago: ',
        en: 'Payment Terms: ',
    },
    terminosInco: {
        es: 'Términos Inco: ',
        en: 'InconTerms: ',
    },
    comentario: {
        es: 'Comentario: ',
        en: 'Comment: .',
    },

    // FIRMAS
    deptoCompras: {
        es: 'Departamento de Compras',
        en: 'Purchasing Department',
    },



    // FOOTER
    textFinal: {
        es: 'Declaro que la información anterior es correcta. Entiendo que "Prime Performance Fabrics, S.A de C.V" podrá contactar y/o utilizar otras fuentes que le permitan investigar la información credicia que considere necesaria para este fin. Autorizamos a las empresas comerciales que figuran en esta solicitud a proveer lo necesario para ayudar a "Prime Performance Fabrics, S.A de C.V", a establecer una línea de crédito.',
        en: 'I declare that the above information is correct. I understand that "Prime Performance Fabrics, S.A de C.V" may contact and/or use other sources that allow it to investigate the credit information it considers necessary for this purpose. We authorize the commercial companies listed in this application to provide what is necessary to help "Prime Performance Fabrics, S.A de C.V", establish a line of credit.',
    },
    textFinal1: {
        es: '*Si tiene alguna duda con respecto a algún espacio, por favor escriba o llame al +504 9439-9000',
        en: '*If you have any questions regarding any space, please write or call +504 9439-9000',
    },
    revisadoPor: {
        es: 'Revisado por',
        en: 'Reviewed by'
    },
    fechaRevision: {
        es: 'Fecha revisión',
        en: 'Review date'
    },
    opcionPago: {
        es: 'Terminos de Pago',
        en: 'Payment Terms'
    },
    // PARTE IV
    parteIV: {
        es: 'PARTE IV: INFORMACIÓN FINANCIERA',
        en: 'PART IV: FINANCIAL INFORMATION',
    },
    ActivoCorriente: {
        es: 'Activo Corriente',
        en: 'Current Assets'
    },
    TotalActivo: {
        es: 'Total Activo',
        en: 'Total Assets'
    },
    PasivoCorriente: {
        es: 'Pasivo Corriente',
        en: 'Current Liabilities'
    },
    TotalPasivo: {
        es: 'Total Pasivo',
        en: 'Total Liabilities'
    },
    //Parte V
    parteV:{
        es:'PARTE V: DECLARACIÓN DE SITUACIÓN FISCAL',
        en:'PART V: STATEMENT OF TAX STATUS'
    }
}